function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { node, oneOf, string, object } from 'prop-types';
import { designTokenPropTypes } from '@immediate_media/design-tokens';
import { nonNegativeInteger } from 'airbnb-prop-types';
import cn from 'classnames';
import { useDesignTokens } from '../../hooks';
/**
 * Heading component.
 */

var Heading = function Heading(_ref) {
  var as = _ref.as,
      children = _ref.children,
      size = _ref.size,
      type = _ref.type,
      styledSize = _ref.styledSize,
      color = _ref.color,
      className = _ref.className,
      style = _ref.style;
  var TagName = as || "h".concat(size);

  var _useDesignTokens = useDesignTokens(),
      colors = _useDesignTokens.colors;

  return /*#__PURE__*/React.createElement(TagName, {
    className: cn(className, "".concat(type === 'default' || !type ? '' : "".concat(type, "-"), "heading-").concat(styledSize || size || 1)),
    style: color || style ? _objectSpread(_objectSpread({}, color && {
      color: color === 'inherit' ? 'inherit' : colors[color]
    }), style) : null
  }, children);
};

Heading.defaultProps = {
  as: null,
  children: '',
  className: '',
  size: 1,
  type: 'default',
  styledSize: null,
  color: null,
  style: null
};
Heading.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Children to be rendered inside the heading component. */
  children: node,

  /** The size of the heading tag. */
  size: oneOf([1, 2, 3, 4, 5, 6]),

  /** Additional classes to be added to the root of the component. */
  className: string,

  /** Custom inline style overrides. */
  style: object,

  /** The type of heading. */
  type: oneOf(['default', 'section', 'hero-content']),

  /** An alternative size for the styling class (e.g. heading-3), the default
    behaviour to use the same size as the size prop. */
  styledSize: nonNegativeInteger,

  /** Render an alternative root tag. For example, use a span instead of an h1
    element if the heading is only being used for presentation purposes. */
  as: string,

  /** The text colour override. */
  color: designTokenPropTypes.color
} : {};
export default Heading;